import React, { useState } from "react";
import Select from "react-select";
import '../css/ContactForm.css';

interface FormData {
  requestType: string;
  name: string;
  companyName: string;
  companyType: string;
  country: string;
  email: string;
  phone: string;
  message: string;
  file: File | null;
}

const ContactForm1: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    requestType: "",
    name: "",
    companyName: "",
    companyType: "",
    country: "",
    email: "",
    phone: "",
    message: "",
    file: null,
  });

  const [errors, setErrors] = useState<string[]>([]); // To store error messages

  const requestOptions = [
    { value: "General Inquiry", label: "General Inquiry" },
    { value: "Quotation Request", label: "Quotation Request" },
    { value: "Order Related Query", label: "Order Related Query" },
    { value: "Service Related Query", label: "Service Related Query" },
  ];

  const companyOptions = [
    { value: "OEM / End User", label: "OEM / End User" },
    { value: "TUC Existing Customer", label: "TUC Existing Customer" },
    { value: "Trader / Reseller", label: "Trader / Reseller" },
    { value: "Other", label: "Other" },
  ];

  const validateForm = (): boolean => {
    const errorMessages: string[] = [];

    // Check if required fields are empty
    if (!formData.requestType) errorMessages.push("Type of Request is required.");
    if (!formData.name) errorMessages.push("Name is required.");
    if (!formData.companyName) errorMessages.push("Company Name is required.");
    if (!formData.companyType) errorMessages.push("Company Type is required.");
    if (!formData.country) errorMessages.push("Country is required.");
    if (!formData.email) errorMessages.push("Email is required.");
    if (!formData.message) errorMessages.push("Message is required.");

    if (errorMessages.length > 0) {
      setErrors(errorMessages); // Set error messages to state
      return false;
    }

    setErrors([]); // Clear errors if form is valid
    return true;
  };

  const handleChange = (selectedOption: any, field: string) => {
    // Ensure selectedOption is not null and handle the value appropriately
    const value = selectedOption ? selectedOption.value : "";
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData({ ...formData, file: e.target.files[0] });
    }
  };

 
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate form
    if (!validateForm()) return; // If form is not valid, stop submission

    // Mock email sending (for example purposes, you would use an email API here)
    console.log("Form Data Submitted:", formData);

    // Mock email details (replace with your email API logic)
    const emailContent = `
      Request Type: ${formData.requestType}
      Name: ${formData.name}
      Company Name: ${formData.companyName}
      Company Type: ${formData.companyType}
      Country: ${formData.country}
      Email: ${formData.email}
      Phone: ${formData.phone}
      Message: ${formData.message}
    `;
    console.log("Sending email with the following content:\n", emailContent);

    const email = "sales@tuc.org.in;rahul@tuc.org.in";
    const subject = `${formData.requestType}`;
    const body = encodeURIComponent(`${emailContent}`);
    
    window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
  
    // Reset the form
    setFormData({
      requestType: "",
      name: "",
      companyName: "",
      companyType: "",
      country: "",
      email: "",
      phone: "",
      message: "",
      file: null,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="p-4 border rounded shadow-sm">
      <div className="mb-3">
        <label className="form-label required">Type of Request</label>
        <Select
         placeholder={'Select Type of Request'}
          options={requestOptions}
          value={requestOptions.find((option) => option.value === formData.requestType) || null}
          onChange={(selectedOption) => handleChange(selectedOption, "requestType")}
        />
         {errors.includes("Type of Request is required.") && (
        <div className="text-danger">Type of Request is required.</div>
      )}

      </div>

      {/* Display error message for requestType */}
     
      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label required">Name</label>
          <input
            type="text"
            className="form-control"
            name="name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
      {/* Display error messages */}
      {errors.includes("Name is required.") && (
        <div className="text-danger">Name is required.</div>
      )}
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label required">Company Name</label>
          <input
            type="text"
            className="form-control"
            name="companyName"
            value={formData.companyName}
            onChange={(e) => setFormData({ ...formData, companyName: e.target.value })}
          />
          {/* Display error messages */}
      {errors.includes("Company Name is required.") && (
        <div className="text-danger">Company Name is required.</div>
      )}

        </div>
      </div>

      
      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label required">Company Type</label>
          <Select
            options={companyOptions}
            value={companyOptions.find((option) => option.value === formData.companyType) || null}
            onChange={(selectedOption) => handleChange(selectedOption, "companyType")}
          />
      {errors.includes("Company Type is required.") && (
        <div className="text-danger">Company Type is required.</div>
      )}

        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label required">Country</label>
          <input
            type="text"
            className="form-control"
            name="country"
            value={formData.country}
            onChange={(e) => setFormData({ ...formData, country: e.target.value })}
          />
      {errors.includes("Country is required.") && (
        <div className="text-danger">Country is required.</div>
      )}

        </div>
      </div>


      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label required">Email</label>
          <input
            type="email"
            className="form-control"
            name="email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          />
      {errors.includes("Email is required.") && (
        <div className="text-danger">Email is required.</div>
      )}

        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label">Phone</label>
          <input
            type="tel"
            className="form-control"
            name="phone"
            value={formData.phone}
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          />
        </div>
      </div>

      {/* <div className="mb-3">
        <label className="form-label">Upload File</label>
        <input type="file" className="form-control" onChange={handleFileChange} />
      </div> */}

      <div className="mb-3">
        <label className="form-label required">Message</label>
        <textarea
          className="form-control"
          rows={4}
          name="message"
          value={formData.message}
          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
        />
      </div>

      {/* Display error message for message */}
      {errors.includes("Message is required.") && (
        <div className="text-danger">Message is required.</div>
      )}

      <button type="submit" className="btn btn-secondary w-100">
        Send your message
      </button>
    </form>
  );
};

export default ContactForm1;
